import ApiService from "./ApiService";
import GeneralUtils from '../utilities/GeneralUtils';
import ApiUtils from "../utilities/ApiUtils";

export class InstitutionService {

    async getInstitutions() {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get('/institutions')
                .then(response => { resolve(response.data) })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getInstitutionsByCriteria(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .post(`/institution/list`, criteria)
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    async getInstitutionsForUserByCriteria(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .post(`/institution/list/for-user`, criteria)
                .then((response) => {
                    let _institutions = []
                    response.data.forEach(element => {
                        _institutions.push({ label: element.name, value: element.id })
                    });

                    resolve(_institutions)
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    async syncInstitutions() {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/institution/sync')
                .then(response => {
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveErrorArray(error))
                })
        })
    }

    async getNomInstitutionTypeByName(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/institution-type/list`, criteria)
                .then(response => {
                    let types = []
                    response.data.forEach(element => {
                        types.push({ label: element.name, value: element.id, type: element.type })
                    });

                    resolve(types)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async findDepartmentTypeByName(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/institution-department-type/list`, criteria)
                .then(response => { resolve(response.data) })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async findDepartmentNameByName(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/institution-department-name/list`, criteria)
                .then(response => { resolve(response.data) })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async findPositionByName(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/institution-position/list`, criteria)
                .then(response => { resolve(response.data) })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async findPositionClassByName(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/institution-class/list`, criteria)
                .then(response => { resolve(response.data) })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async findPositionLevelByName(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/institution-level/list`, criteria)
                .then(response => { resolve(response.data) })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async findInstitutionJobByCriteria(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/institution-job/list`, criteria)
                .then(response => { resolve(response.data) })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async syncIntitutionJobs() {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/institution/job/sync')
                .then(response => {
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveErrorArray(error))
                })
        })
    }
}